// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { EMRExportCountsType } from "../../types";
import { getEMRExportCounts } from "../../api";

export const useEMRExportCounts = (
  clinicId: string | undefined,
  connectionId: string | undefined,
  enabled: boolean
) => {
  const { getToken } = useTokenAccess();

  return useQuery<EMRExportCountsType>({
    queryKey: ["emr-export-counts", clinicId, connectionId],
    queryFn: async () => {
      if (!clinicId || !connectionId) throw new Error();
      const token = await getToken();
      return getEMRExportCounts(token, clinicId, connectionId);
    },
    enabled: enabled && Boolean(clinicId && connectionId),
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};
